/*
 * Foreva Kaash password page + shop pages ("Remind me when this drops"): on-page SMS signup + Meta Lead.
 *
 *   - Omnisend renders the embedded form into the [data-fk-signup] <dialog> (its app embed does
 *     the rendering; this file never builds form fields). Any [data-fk-signup-open] link opens
 *     that dialog instead of leaving the site. If Omnisend hasn't rendered the form (blocked,
 *     slow, disabled), the click is left alone and the link's href, the hosted form, opens.
 *   - Meta Lead fires ONLY when Omnisend reports a successful submit of THIS form that carries
 *     a phone number. Omnisend dispatches `omnisendForms` {type:'submit', form, formValues}
 *     after its subscribe request succeeds (a failed request never dispatches it). Opening the
 *     panel, typing, and validation errors send nothing.
 *   - The Facebook & Instagram app's web pixel (runtimeContext OPEN) already loads fbq on this
 *     page and sends PageView, so this reuses that fbq and sends Lead only, once per session.
 *     If the app's pixel is ever missing, it loads fbevents.js itself with autoConfig off and
 *     still sends no PageView. The phone goes in as advanced matching (`ph`); fbevents hashes
 *     it in the browser before sending (verified 2026-10-18: `ud[ph]` is a SHA-256).
 */
(() => {
  const dialog = document.querySelector('[data-fk-signup]');
  if (!dialog) return;
  const formId = dialog.dataset.fkFormId;
  const pixelId = (dialog.dataset.fkPixelId || '').replace(/\D/g, '');
  const mount = dialog.querySelector('.fk-signup__form');
  const rendered = () => !!(mount && mount.querySelector('input'));

  // ---- Meta pixel (Lead only).
  function loadPixel() {
    if (!pixelId || window.fbq) return;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('set', 'autoConfig', false, pixelId);
  }

  // Meta wants digits with the country code, no "+". Omnisend sends the national number in
  // phoneNumberField and the dial code separately, e.g. {phoneNumberField: "2145550142",
  // phoneNumberCountryCodeField: "US", phoneNumberCountryCodeValue: "+1"} (captured 2026-10-18).
  function matchPhone(values) {
    const raw = String(values.phoneNumberField || '');
    const digits = raw.replace(/\D/g, '');
    if (!digits || raw.trim().startsWith('+')) return digits;
    const cc = String(values.phoneNumberCountryCodeValue || '').replace(/\D/g, '') || (digits.length === 10 ? '1' : '');
    return cc + digits;
  }

  const sentKey = 'fk-lead-' + formId;
  function alreadySent() { try { return sessionStorage.getItem(sentKey) === '1'; } catch (e) { return false; } }
  function markSent() { try { sessionStorage.setItem(sentKey, '1'); } catch (e) { /* private mode: page-level guard still holds */ } }
  let sent = false;

  window.addEventListener('omnisendForms', e => {
    const d = e.detail || {};
    const id = d.form && typeof d.form === 'object' ? d.form.id : d.form;
    if (d.type !== 'submit' || id !== formId) return;
    const phone = matchPhone(d.formValues || {});
    if (phone.length < 8) return;                 // no phone number, no Lead
    if (!pixelId || sent || alreadySent()) return;
    sent = true;
    markSent();
    loadPixel();
    window.fbq('init', pixelId, { ph: phone });
    window.fbq('trackSingle', pixelId, 'Lead',
      // the shop pages' dialog says where the signup came from (sold-out reminder); the password page keeps its labels
      { content_name: dialog.dataset.fkLeadName || 'Early access SMS signup', content_category: dialog.dataset.fkLeadCategory || 'password_page' },
      { eventID: 'fk-lead-' + formId + '-' + Date.now() });
  });

  // ---- The panel.
  let opener = null;
  document.addEventListener('click', e => {
    const link = e.target.closest('[data-fk-signup-open]');
    if (!link || !rendered()) return;             // not rendered: the href (hosted form) opens
    e.preventDefault();
    const other = link.closest('dialog[open]');   // the product panel's button
    if (other) other.close();
    opener = other ? document.querySelector('.fk-access') : link;
    loadPixel();                                  // warm fbevents.js before the submit
    dialog.showModal();
  });
  function close() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close', () => { if (opener) opener.focus({ preventScroll: true }); });
  dialog.querySelector('[data-fk-signup-close]').addEventListener('click', close);
  dialog.addEventListener('click', e => { if (e.target === dialog) close(); });
})();
